export class WaitlistEntryDTO {
    constructor(
        public id: string,
        public organisationId: string,
        public venueId: string,
        public firstName: string,
        public lastName: string,
        public emailAddress: string,
        public phoneNumber: string | null,
        public partySize: number,
        public date: string,
        public time: string,
        public reasonId: string | null,
        public eventId: string | null,
        public requiresWheelchairAccess: boolean,
        public requiresDogFriendly: boolean,
        public requiresPramAccessible: boolean,
        public requiresHighchairFriendly: boolean,
        public dateCreated: string,
        public dateUpdated: string,
    ) { }
}

export class CreateWaitlistEntryDTO {
    constructor(
        public firstName: string,
        public lastName: string,
        public emailAddress: string,
        public phoneNumber: string | null,
        public partySize: number,
        public date: string,
        public time: string,
        public reasonId: string | null,
        public eventId: string | null,
        public requiresWheelchairAccess: boolean,
        public requiresDogFriendly: boolean,
        public requiresPramAccessible: boolean,
        public requiresHighchairFriendly: boolean,
    ) { }
}
